'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Locations;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GoogleMap = require('./GoogleMap');

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

var _Location = require('./Location');

var _Location2 = _interopRequireDefault(_Location);

var _renderTitle = require('shared/modules/utils/renderTitle');

var _renderTitle2 = _interopRequireDefault(_renderTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   {
     "type": "locations",
     "title": "Locations",
     "locations": [
       {
         "title": "West Campus",
         "address": {
           "line1": "999 E. New York St.",
           "line2": "",
           "city": "New York",
           "state": "NY",
           "zip": "99999",
           "phone": "(999) 999-9999",
           "email": "west.campus@college.edu"
         }
       },
       {
         "title": "South Campus",
         "address": {
           "line1": "999 E. New York St",
           "line2": "",
           "city": "Cityname",
           "state": "NJ",
           "zip": "99999",
           "phone": "(999) 999-9999"
         }
       },
       {
         "title": "Jersey City Campus",
         "address": {
           "line1": "999 E. New York St",
           "line2": "",
           "city": "Jersey City",
           "state": "NJ",
           "zip": "99999",
           "phone": "(999) 999-9999"
         }
       }
     ]
   }

   Displays a list of locations on a Google Map.

   In a location object, line2 and email are
   optional fields, and if omitted will not be displayed.

   The address fields will be used to calculate the latitude
   and longitude. phone and email (if present) will be
   displayed in the popup bubble when clicking on a location.
*/

function Locations(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      locations = _ref.locations;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-locations ' + moduleClass
    },
    (0, _renderTitle2.default)(title),
    _react2.default.createElement(_GoogleMap2.default, { locations: locations }),
    _react2.default.createElement(
      'div',
      { className: 'location-list' },
      locations.map(function (location, key) {
        return _react2.default.createElement(_Location2.default, {
          key: key,
          location: location,
          index: key + 1
        });
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Locations/Locations.jsx
// module id = 1219
// module chunks = 0